module.exports = __webpack_public_path__ + "static/r_ke.15c0d79c.svg";